import React, {useEffect, useState} from 'react';
import axios from "axios";
import {Card, FloatingLabel, FormControl, Stack, Form, CardImg, Spinner, Button} from "react-bootstrap";
import {useLocation, useParams} from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import ArrowUp from "../assets/ArrowUp";



const AudioButton = (props: {hOffset: string, yOffset: string, size: number}) => {
    return (
        <img style={{position:'absolute', top: `${props.yOffset}%`, left: `${props.hOffset}%`, width: props.size, height: props.size}} width={props.size} height={props.size} src={require('../assets/newAudioIcon.png')}/>
    )
}


const VideoButton = (props:  {hOffset: string, yOffset: string; size: number}) => {
    return (
        <img style={{position:'absolute', top: `${props.yOffset}%`, left: `${props.hOffset}%`}} width={props.size} height={props.size} src={require('../assets/newVideoIcon.png')}/>
    )
}

const PageCard = (props: {index: number; addElementsToPage: any; URL_PREFIX: string; page: any; changePosition: any; deleteButtonFromPage: any; changeButtonType:any; changeButtonTime: any; loadFile: any; clearFileFromPage: any; audioSize: number; videoSize: number}) => {

    return (
        <>
            {props.page && props.page.image && (
                <Stack>
                    <Stack direction={'horizontal'} className={'p-3'}>
                        <div style={{position:'relative'}}>
                            <img width={525} height={700}  style={{objectFit: "cover"}} src={props.URL_PREFIX + props.page.image}/>
                            {props.page.buttons.map((item: { type: string; hOffset: string; yOffset: string; }, index: number) =>(
                                <>
                                    {item.type === 'audio' && (
                                        <AudioButton hOffset={item.hOffset} yOffset={item.yOffset} size={props.audioSize}/>
                                    )}
                                    {item.type === 'video' && (
                                        <VideoButton hOffset={item.hOffset} yOffset={item.yOffset} size={props.videoSize}/>
                                    )}
                                </>
                            ))}
                        </div>
                        <Stack style={{backgroundColor: '#e9e9e9', margin: 20, borderRadius: 10, maxHeight: 700, overflowY: 'scroll'}}>
                            <button onClick={()=>props.addElementsToPage(props.index)} style={{margin:10,color: 'white' , backgroundColor: 'rgba(65,93,74,0.95)'}}>Добавить кнопку</button>
                            {props.page.buttons.map(function (button: any, idx: number) {
                                return (

                                    <>
                                        {props.page.buttons && (
                                            <Stack key={idx+'elements'} className={'m-3'} style={{borderWidth: 2, borderColor: '#666666', borderRadius: 5, borderStyle: 'solid', }}>
                                                <Stack direction={'horizontal'}>
                                                    <Form.Select value={button.type} onChange={(e)=>props.changeButtonType(e.target.value, idx, props.index)} className={'mb-3'} style={{width: '90%'}}>
                                                        <option value={'audio'}>Аудио</option>
                                                        <option value={'video'}>Видео</option>
                                                    </Form.Select>

                                                    <img className={'mb-3'} src={require('../assets/trash.png')} width={24} height={24} style={{marginLeft: 30, cursor: 'pointer'}} onClick={()=>props.deleteButtonFromPage(idx, props.index)}/>

                                                </Stack>
                                                <>
                                                    <Form.Label>Горизонтальное положение</Form.Label>
                                                    <Form.Range value={button.hOffset} min={0} max={100} onChange={(e)=>props.changePosition('x', e.target.value, idx, props.index)}/>
                                                </>
                                                <>
                                                    <Form.Label>Вертикальное положение</Form.Label>
                                                    <Form.Range value={button.yOffset} min={0} max={100} onChange={(e)=>props.changePosition('y', e.target.value, idx, props.index)}/>
                                                </>
                                                <Stack direction={'horizontal'} className={'mt-3'}>
                                                    <FloatingLabel
                                                        style={{width: '50%'}}
                                                        controlId="floatingInput"
                                                        label="Время появления в милисекундах ( например: 3000 мсек  = 3 сек)"
                                                    >
                                                        <Form.Control onChange={(e)=>props.changeButtonTime('start', e.target.value, idx, props.index, idx,  props.index)} value={button.timeWhenShow} placeholder={'Обложка'}  type={'number'} />
                                                    </FloatingLabel>
                                                    <FloatingLabel
                                                        style={{width: '50%'}}
                                                        controlId="floatingInput"
                                                        label="Время исчезновеня в милисекундах ( например: 3000 мсек  = 3 сек)"
                                                    >
                                                        <Form.Control onChange={(e)=>props.changeButtonTime('end', e.target.value, idx, props.index, idx,  props.index)} value={button.timeWhenHide} placeholder={'Обложка'}  type={'number'} />
                                                    </FloatingLabel>
                                                </Stack>
                                            </Stack>
                                        )}
                                    </>

                                )
                            })}
                        </Stack>

                    </Stack>
                    <Stack direction={'horizontal'}>
                        <Stack className={'p-2'}>
                            <>
                                <Form.Label> {(props.page.audio && props.page.audio.length>0) ? `Аудио загружено: ${props.page.audio[0]}` : 'Аудио не загружено'}{props.page.audio && props.page.audio.length>0 && (<Button onClick={()=> props.clearFileFromPage('audio', props.index)}>X</Button>)}</Form.Label>
                                <Form.Control placeholder={'Обложка'}  type={'file'} onChange={(e)=>{props.loadFile('audio', e, props.index)}}/>
                            </>
                        </Stack>
                        <Stack className={'p-2'}>
                            <>
                                <Form.Label>{(props.page.video && props.page.video.length>0) ? `Видео загружено: ${props.page.video[0]}` : 'Видео не загружено'}{props.page.video && props.page.video.length>0 && (<Button onClick={()=> props.clearFileFromPage('video', props.index)}>X</Button>)} </Form.Label>
                                <Form.Control placeholder={'Обложка'} multiple  type={'file'} onChange={(e)=>{props.loadFile('video', e, props.index)}}/>
                            </>
                        </Stack>
                    </Stack>
                    <>
                        <Form.Label>{(props.page.mag) ? `Изображение для лупы загружено: ${props.page.mag}` : 'Изображение для лупы не загружено'} {props.page.mag && (<Button onClick={()=> props.clearFileFromPage('mag', props.index)}>X</Button>)}</Form.Label>
                        <Form.Control placeholder={'Обложка'} multiple  type={'file'} onChange={(e)=>{props.loadFile('mag', e, props.index)}}/>
                    </>
                </Stack>
            )}
        </>
    )
}

const EditTale = (props: any) => {
    const [currentPageIndex, setCurrentPageIndex] = useState(0)
    const [uploadedPages, setUploadedPages] = useState<any>([])
    const [pagesElements, setPagesElements] = useState<any>({})
    const [tale, setTale] = useState<any>(null)
    const [uploadedFiles, setUploadedFiles] = useState<any>([])
    const [fileLimit, setFileLimit] = useState(false);
    const [loader, setLoader] = useState<boolean>(false);
    const MAX_COUNT = 5;
    const URL_PREFIX = 'http://kitap.alsu.tatar';
    const params = useParams()
    const navigate = useNavigate();



    useEffect(()=>{
        axios.get('http://kitap.alsu.tatar/api/tale/get/'+params.id).then((response)=>{
            setTale(response.data.message)
            console.log(response.data.message)
        })
    }, [])

    const handleUploadFiles = (filesA: any) => {
        const uploaded = [...uploadedFiles];
        let limitExceeded = false;
        filesA.some((file: any) => {
            if (uploaded.findIndex((f: any) => f.name === file.name) === -1) {
                uploaded.push(file);
                if (uploaded.length === MAX_COUNT) setFileLimit(true);
                if (uploaded.length > MAX_COUNT) {
                    alert(`You can only add a maximum of ${MAX_COUNT} files`);
                    setFileLimit(false);
                    limitExceeded = true;
                    return true;
                }
            }
        })
        if (!limitExceeded) setUploadedFiles(uploaded)


    }

    const handleFileEvent =  (e: any) => {
        const chosenFiles = Array.prototype.slice.call(e.target.files)
        handleUploadFiles(chosenFiles);

    }


    function handleAddButton() {
        setTale({...tale, pages: {
                [currentPageIndex]: {
                    buttons: {
                        type: 'add',
                        hOffset: 10,
                        yOffset: 11,
                        timeWhenShow: 1000,
                        timeWhenHide: 3000
                    }
                }
            }})
    }

    async function saveFileToStorage(event: any, mode: string) {
        let path = ''
        if (mode === 'cover') {
            path = `${tale.folder}`
        }
        if (mode==='titleCover' || mode==='lastCover' || mode==='pages' || mode === 'coverAudio') {
            path = `${tale.folder}/pages`
        }

        let answer = await on_form_submit(event, path)
        console.log(answer)
        let paths: any[] = []
        answer.data.forEach((item: { path: any; }) => {
            paths.push(item.path)
        })
        if (mode === 'cover') {
            setTale({...tale,  cover: paths[0]})
        }
        if (mode === 'titleCover') {
            setTale({...tale,  pages: {
                    ...tale.pages,
                    titleCover: paths[0],
                }})
        }
        console.log(mode)
        if (mode === 'lastCover') {
            setTale({...tale,  pages: {
                    ...tale.pages,
                    lastCover: paths[0],
                }})
        }
        if (mode === 'coverAudio') {
            setTale({...tale,  coverAudio: paths[0]})
        }
        if (mode === 'pages') {
            let tmp: any = tale.pages
            paths.forEach((path, idx)=>{
                console.log({[idx+1]: path})
                tmp[idx+1] = {image: path, buttons: [], video: [], audio: [],}
            })
            setTale({...tale,  pages: {...tmp}})
        }

    }

    async function addAudioVideo(mode: string, event: any, pageIdx: number) {

        let path = ''
        if (mode === 'audio') {
            path = `${tale.folder}/audio`
        }
        if (mode === 'video') {
            path = `${tale.folder}/video`
        }
        if (mode === 'mag') {
            path = `${tale.folder}`
        }
        let answer = await on_form_submit(event, path)
        console.log(answer)

        let paths: any[] = []
        answer.data.forEach((item: { path: any; }) => {
            paths.push(item.path)
        })
        if (mode ===  'audio') {
            let tmp: any = tale.pages
            tmp[pageIdx].audio = paths
            setTale({...tale,  pages: {...tmp}})

        }
        if (mode ===  'video') {
            let tmp: any = tale.pages
            tmp[pageIdx].video = paths
            setTale({...tale,  pages: {...tmp}})

        }
        if (mode ===  'mag') {
            let tmp: any = tale.pages
            tmp[pageIdx].mag = paths[0]
            setTale({...tale,  pages: {...tmp}})
        }


    }

    // @ts-ignore
    const on_form_submit = async (e, path) => {
        e.preventDefault();
        setLoader(true)
        console.log(Array.prototype.slice.call(e.target.files))
        let data = new FormData();
        // @ts-ignore
        Array.prototype.slice.call(e.target.files).forEach(file => {
            data.append('files', file);
        })
        data.append('title', tale.title)
        console.log('111',e);
        var config = {
            method: 'post',
            url: 'http://kitap.alsu.tatar/api/upload_f',
            headers: {
                'Access-Control-Allow-Origin': '*',
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                path: path
            },
            data : data
        };

        let answer: any = await axios(config)
            .catch(function (error) {
                console.log(error);
            });
        setLoader(false)
        return answer.data

    };

    function changePosition (direction: string, position: number, buttonIdx: number, pageIdx: number) {
        console.log(direction, position, buttonIdx)
        let tmp = tale.pages
        if (tmp[pageIdx] && tmp[pageIdx].buttons) {
            if (direction==='x') {
                tmp[pageIdx].buttons[buttonIdx] = {...tmp[pageIdx].buttons[buttonIdx] , hOffset: position }
            }
        }
        if (tmp[pageIdx] && tmp[pageIdx].buttons) {
            if (direction==='y') {
                tmp[pageIdx].buttons[buttonIdx] = {...tmp[pageIdx].buttons[buttonIdx] , yOffset: position }
            }
        }
        setTale({...tale,  pages: tmp})
    }

    function changeButtonType (type: string, buttonIdx: number, pageIdx: number) {
        let tmp = tale.pages
        if (tmp[pageIdx] && tmp[pageIdx].buttons) {
            tmp[pageIdx].buttons[buttonIdx] = {...tmp[pageIdx].buttons[buttonIdx] , type: type }
        }
        setTale({...tale,  pages: tmp})
    }

    function addElementsToPage(page: number) {
        let tmp = tale.pages
        console.log(page, tmp[page])
        if (tmp[page] && tmp[page].buttons) {
            tmp[page].buttons.push({
                type: 'audio',
                hOffset: 50,
                yOffset: 50,
                timeWhenShow: 0,
                timeWhenHide: 0,
            })

        } else {
            tmp[page] = {buttons: []}
        }

        console.log('tmp', tmp)
        setTale({...tale,  pages: {...tmp}})
    }

    function deleteButtonFromPage(elementIdx: number, pageIdx: number) {
        let tmp = tale.pages
        console.log(elementIdx, pageIdx, 'jnbjjbdj')
        tmp[pageIdx].buttons.splice(elementIdx, 1)
        setTale({...tale,  pages: {...tmp}})
    }
    function deletePage(pageIdx: number) {
        let tmp = tale.pages

        delete tmp[pageIdx]
        setTale({...tale,  pages: {...tmp}})
        console.log(tmp)
    }

    function clearFileFromPage(mode: string, pageIdx: number) {
        if (mode === 'mag') {
            let tmp = tale.pages
            delete tmp[pageIdx].mag
            setTale({...tale, pages: {...tmp}})
        }
        if (mode === 'video') {
            let tmp = tale.pages
            tmp[pageIdx].video = []
            setTale({...tale, pages: {...tmp}})
        }
        if (mode === 'audio') {
            let tmp = tale.pages
            tmp[pageIdx].audio = []
            setTale({...tale, pages: {...tmp}})
        }
    }

    function changeButtonTime(type: string, value: number, idx: number, pageIdx: number) {
        let tmp =  tale.pages
        if (type==='start') {
            tmp[pageIdx].buttons[idx]={...tmp[pageIdx].buttons[idx], timeWhenShow: value}
        }
        if (type==='end') {
            tmp[pageIdx].buttons[idx]={...tmp[pageIdx].buttons[idx], timeWhenHide: value}
        }
        setTale({...tale, pages: {...tmp}})
    }

    async function saveTale() {
        console.log('===== saveTale begins ====')
        let answer = await axios.post(`${URL_PREFIX}/api/tale/edit`, tale)
        navigate('/admin/catalog')
        console.log(answer.data)
        console.log('===== saveTale begins ====')

    }

    useEffect(()=>{
        let isAuthenticated = localStorage.getItem('@logged')
        //@ts-ignore
        isAuthenticated = JSON.parse(isAuthenticated)
        if (!isAuthenticated) {
            navigate('/admin')
        }
    }, [])



    // @ts-ignore
    // @ts-ignore
    return (
        <>
            {tale && (
                <Stack style={{position: 'relative', backgroundColor: '#414845', width: '100%', height: '100%', margin: '1%', display: 'flex', flexDirection: 'column', alignItems: 'center',}} className={'pt-5'}>
                    <div style={{position: 'absolute', top: 10, left: 10, fontSize: 20, color: '#eeefff', fontWeight: 'bold'}}><span>Редактируем историю</span></div>
                    <hr/>
                    <Card style={{backgroundColor: '#eee',  width: '80%', height: '100%'}}>
                        <Card.Title className={'pl-3'} style={{backgroundColor: 'rgba(65,93,74,0.95)', height: 48, alignItems: 'center', justifyContent: 'space-between', flexDirection: 'row', display: 'flex', paddingLeft: 30}}>
                            <span style={{color:'white'}}>Общая информация</span>
                            <img className={'me-3'} src={require('../assets/floppydisk.png')} width='24' height='24' alt={''} onClick={saveTale}/>
                        </Card.Title>
                        <Card.Text>
                            <Stack direction={'horizontal'} className={'me-3'} style={{justifyContent: 'space-between'}}>
                                <Form.FloatingLabel label={'Индекс сортировки'} style={{marginLeft: 40}}>
                                    <Form.Control type={'number'} value={tale.index ? tale.index : 0} onChange={(e)=>setTale({...tale, index: parseInt(e.target.value)})} />
                                </Form.FloatingLabel>
                                <Form.Check
                                    size={20}
                                    checked={tale.approved}
                                    value={tale.approved}
                                    type={'switch'}
                                    label={'Опубликовано'}
                                    onChange={(e)=>{
                                        console.log('switch', e.target.checked); setTale({...tale, approved: e.target.checked})}}
                                />
                            </Stack>
                            <Stack style={{width: '100%', padding: 20}} direction={'horizontal'}>
                                <FloatingLabel
                                    controlId="floatingInput"
                                    label="Название книги"
                                    style={{width: '60%'}}
                                >
                                    <Form.Control placeholder={'Название книги'} type="text" value={tale.title} onChange={(event)=>{
                                        console.log(event.target.value); setTale({...tale,  title: event.target.value})}}/>
                                </FloatingLabel>
                                <FloatingLabel
                                    controlId="floatingInput"
                                    label="Имя папки на сервере"
                                    placeholder={'Только цифры и символы лат. алфавита'}
                                    style={{width: '40%'}}

                                >
                                    <Form.Control placeholder={'Название книги'} type="text" value={tale.folder} onChange={(event)=>{
                                        let value = event.target.value;
                                        value = value.replace(/[^A-Za-z0-9]/gi, ""); setTale({...tale,  folder: value})}}/>
                                </FloatingLabel>
                            </Stack>
                            <Stack  style={{width: '100%', padding: 20}}>
                                <Stack style={{width: '100%', padding: 20}}>
                                    <span style={{textAlign: 'left'}}>Обложка для каталога</span>
                                    <Form.Control disabled={!tale.folder} placeholder={'Обложка'}  type={'file'} onChange={(e)=>saveFileToStorage(e, 'cover')}/>
                                </Stack>
                                <Stack direction={'horizontal'}>
                                    <Stack style={{width: '100%', padding: 20}}>
                                        <span style={{textAlign: 'left'}}>Титульная обложка книги</span>
                                        <Form.Control disabled={!tale.folder} placeholder={'Обложка'}  type={'file'} onChange={(e)=>saveFileToStorage(e, 'titleCover')}/>
                                    </Stack>
                                    <Stack style={{width: '100%', padding: 20}}>
                                        <span style={{textAlign: 'left'}}>Звук обложки</span>
                                        <Form.Control disabled={!tale.cover} placeholder={'Обложка'}  type={'file'} onChange={(e)=>saveFileToStorage(e, 'coverAudio')}/>
                                    </Stack>
                                    <Stack style={{width: '100%', padding: 20}}>
                                        <span style={{textAlign: 'left'}}>Закрывающая обложка книги</span>
                                        <Form.Control disabled={!tale.folder} placeholder={'Обложка'}  type={'file'} onChange={(e)=>saveFileToStorage(e, 'lastCover')}/>
                                    </Stack>

                                </Stack>
                                <Stack direction={'horizontal'} className={'my-2'} style={{width: '100%', height: 2, backgroundColor: '#aaa'}} />
                                <span style={{textAlign: 'left'}}>Страницы книги</span>
                                <Form.Control disabled={!tale.folder} placeholder={'Обложка'} multiple  type={'file'} onChange={(e)=>saveFileToStorage(e, 'pages')}/>
                                <Stack direction={'horizontal'}>
                                    <Stack className={'mt-5 p-4'} style={{width: '50%'}}>
                                        <Stack direction={'horizontal'} style={{justifyContent: 'space-between', alignItems: 'center',}}>
                                            <p>Размер значка Аудио - {tale.audioSize ? tale.audioSize : 40}px</p>
                                            <img src={require('../assets/newAudioIcon.png')} width={tale.audioSize ? tale.audioSize : 40}/>
                                        </Stack>
                                        <Form.Range min={20} max={100} value={tale.audioSize ? tale.audioSize : 40} onChange={(e)=>setTale({...tale, audioSize: e.target.value})}/>
                                    </Stack>
                                    <Stack className={'mt-5 p-4'} style={{width: '50%'}}>
                                        <Stack direction={'horizontal'} style={{justifyContent: 'space-between', alignItems: 'center',}}>
                                            <p>Размер значка Видео - {tale.videoSize ? tale.videoSize : 40}px</p>
                                            <img src={require('../assets/newVideoIcon.png')} width={tale.videoSize ? tale.videoSize : 40}/>

                                        </Stack>
                                        <Form.Range min={20} max={100} value={tale.videoSize ? tale.videoSize : 40} onChange={(e)=>setTale({...tale, videoSize: e.target.value})}/>
                                    </Stack>
                                </Stack>
                            </Stack>
                            {/*<label className={'mx-auto'} style={{width: 400, flexDirection: 'column', borderStyle: 'dashed', borderWidth:2, borderColor: '#222', alignItems: 'center', justifyContent: 'center'}}>*/}
                            {/*    <input  style={{opacity: 0, height:10}} type='file' multiple placeholder={'Обложка'} onChange={saveFileToStorage}/>*/}
                            {/*    <span style={{color: '#000', fontSize: 16, lineHeight: '16px'}}>Перетащите файлы сюда или выберите в диалоге чтобы загрузить страницы книги (без обложек)</span>*/}
                            {/*</label>*/}
                        </Card.Text>
                    </Card>
                    {Object.keys(tale.pages).map((page: any, index)=>(
                        <Card style={{width: '80%'}} className={'mt-5'} key={page.image}>
                            <Card.Title>

                                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 20, marginInline: 20}}>
                                    Страница {index+1}
                                    <img className={'mb-3'} src={require('../assets/trash.png')} width={24} height={24} style={{marginLeft: 30, cursor: 'pointer'}} onClick={()=>deletePage(index+1)}/>
                                </div>
                            </Card.Title>
                            <Card.Text style={{width: '100%', backgroundColor: '#877878'}}>
                                <PageCard clearFileFromPage={clearFileFromPage} index={index+1} changeButtonType={changeButtonType}  URL_PREFIX={URL_PREFIX} addElementsToPage={addElementsToPage}  page={tale.pages[index+1]} changePosition={changePosition} deleteButtonFromPage={deleteButtonFromPage} changeButtonTime={changeButtonTime} loadFile={addAudioVideo} audioSize={tale.audioSize} videoSize={tale.videoSize}/>
                            </Card.Text>
                        </Card>
                    ))}

                    <div style={{width: '80%', height: '5px', backgroundColor: '#000', marginLeft: '50%', marginRight: '50%'}} />
                </Stack>
            )}
            <Button style={{backgroundColor: '#efefef', width: '64px', height: '64px', position: 'fixed', bottom: 50, right: 50}} onClick={()=> window.scrollTo({top: 0, left: 0, behavior: 'smooth'})}><ArrowUp /></Button>
            {loader && (
                <Stack direction={'horizontal'} style={{width: '100%', height: '100vh', position:'fixed', alignItems: 'center', justifyContent: 'center', backgroundColor: '#2f2f2fe8'}}>
                    <Spinner animation="grow" variant="primary" />
                    <Spinner animation="grow" variant="secondary" />
                    <Spinner animation="grow" variant="success" />
                    <Spinner animation="grow" variant="danger" />
                    <Spinner animation="grow" variant="warning" />
                    <Spinner animation="grow" variant="info" />
                    <Spinner animation="grow" variant="light" />
                    <Spinner animation="grow" variant="dark" />
                </Stack>
            )}
        </>
    )
};

export default EditTale;
